import './PlatformSidebar.css';
import CreateAccountButton from './CreateAccountButton';
import AddFundsButton from './AddFundsButton.js';
import ImportFromPasswordButton from './ImportFromPasswordButton.js';
import { FaTwitter } from "react-icons/fa";
import { FaDiscord } from "react-icons/fa";
import Wallet from './Wallet';
import React, { Component } from 'react';
import styled from 'styled-components';
import * as scriptUtils from './utils/scriptUtils';
import { ConnectButton } from '@rainbow-me/rainbowkit';
const axios = require('axios');

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    return (
      <div className="opacity-95 inline-flex border-t-2 dark:border-t-2 dark:border-zinc-800 z-10 h-16 items-center w-full justify-between position:fixed left-0 right-0 dark:bg-custom-gray bg-custom-white">
        <div className="mr-10 flex justify-center w-screen items-center sm:text-base text-xs">
            <div className="flex justify-around items-center w-96">
              <div
                className="mr-4 text-xs md:text-xs lg:text-base font-medium text-gray-600 dark:text-gray-400 cursor-pointer"
                onClick={()=> window.open("https://discord.gg/A2xvfvNG9R", "_blank")}
              >
                <div className="flex text-xl flex items-center justify-center">
                  <FaDiscord/>
                </div>
              </div>

              <div
                className="flex mr-4 text-xs md:text-xs lg:text-base font-medium text-gray-600 dark:text-gray-400 cursor-pointer"
                onClick={()=> window.open("https://twitter.com/the402HQ", "_blank")}
              >
              <div className="flex text-xl flex items-center justify-center">
                <FaTwitter/>
              </div>
              </div>
              <div
                className="flex mr-4 text-base font-medium text-gray-600 dark:text-gray-400 cursor-pointer"
                onClick={()=> window.open("https://carbonated-sousaphone-22a.notion.site/FAQ-s-108581fbfe134595876ff9bf9ba3ea74", "_blank")}
              >
                FAQ
              </div>
              <div
                className="flex mr-4 text-base font-medium text-gray-600 dark:text-gray-400 cursor-pointer"
                onClick={()=> window.open("https://mirror.xyz/0x5bd70C712D7499BaBACFdfFBc5EB73C88a23aeaE", "_blank")}
              >
                Mirror
              </div>
          </div>
        </div>
      </div>
    );
  }
}


export default Footer;
